export enum JournalEntryPostingType {
  credit = "credit",
  debit = "debit",
}

export const journalEntryTotalsPostingType = "totals" as const;

export type JournalEntryLinePostingType =
  | JournalEntryPostingType
  | typeof journalEntryTotalsPostingType;

export const parseJournalEntryLinePostingType = (
  value: string | null | undefined,
): JournalEntryPostingType | null => {
  const normalized = value?.trim().toLowerCase();
  if (normalized === "credit") {
    return JournalEntryPostingType.credit;
  }
  if (normalized === "debit") {
    return JournalEntryPostingType.debit;
  }
  return null;
};

export const isJournalEntryPostingType = (
  value: JournalEntryLinePostingType | null,
): value is JournalEntryPostingType =>
  value === JournalEntryPostingType.credit || value === JournalEntryPostingType.debit;
